import { Route } from 'react-router-dom';
import { lazyNamed } from '../lazy-named';
import { ROUTE_PATHS } from '../constants';

const WebsiteHomePage = lazyNamed(() => import('@/features/website'), 'WebsiteHomePage');
const WebsiteTermsPage = lazyNamed(() => import('@/features/website'), 'WebsiteTermsPage');
const WebsitePrivacyPage = lazyNamed(() => import('@/features/website'), 'WebsitePrivacyPage');
const WebsiteSupportPage = lazyNamed(() => import('@/features/website'), 'WebsiteSupportPage');

export function websiteRoutes() {
  return (
    <>
      <Route path={ROUTE_PATHS.WEBSITE} element={<WebsiteHomePage />} />
      <Route path={ROUTE_PATHS.WEBSITE_TERMS} element={<WebsiteTermsPage />} />
      <Route path={ROUTE_PATHS.WEBSITE_PRIVACY} element={<WebsitePrivacyPage />} />
      <Route path={ROUTE_PATHS.WEBSITE_SUPPORT} element={<WebsiteSupportPage />} />
    </>
  );
}
